import React, { Component } from 'react';
import $ from 'jquery';
import { Panel,Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { withRouter } from 'react-router';


class Irregular extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			results: [],
			gradeType: {},
			unitType: {},
    };
    this.onIrregularTestClick = this.onIrregularTestClick.bind(this);
	}

	enumGradeFormatter(cell, row, enumObject) {
		return enumObject[cell];
	}
	
	enumUnitFormatter(cell, row, enumObject) {
		return enumObject[cell];
	}

  onIrregularTestClick() {
    this.props.history.push(`/irregular_test/`);
  }

	componentDidMount() {
		var that = this;
		$(function(){$.ajax({
				url: URL + 'api/irregulars/',
				headers: {
				},
				type: "GET",
				dataType: "json",
				success: function(data) {
				        var gradeType = {};
					var unitType = {};
				        data.forEach((word)=>{
						gradeType[word.grade] = word.grade;
						unitType[word.unit] = word.unit;
					});	
					that.setState({results:data,gradeType:gradeType,unitType:unitType,});
				},
				error: function(xhr, status, err) {
					console.log(err.Message);
					that.setState({results:[]});
				}
			})});
	}

	render() {
		return( 
			<Panel>
			  <Panel.Heading>
          不规则动词表
          <Button 
            onClick={this.onIrregularTestClick} 
            style={{"float":"right"}}
          >
            不规则动词测试
          </Button>
			  </Panel.Heading>
			  <Panel.Body>
			    <BootstrapTable 
			      data={this.state.results} 
			      striped
			      hover
			      pagination
			      options={{ noDataText: '没有可以显示的数据' }}
			    >
			      <TableHeaderColumn isKey hidden dataField='id'>
			        ID
			      </TableHeaderColumn>
			      <TableHeaderColumn 
			      	dataField='grade'
				filterFormatted 
				dataFormat={ this.enumGradeFormatter }
				formatExtraData= { this.state.gradeType }
				filter = {{ type: 'SelectFilter',
					options: this.state.gradeType,
					selectText: '选择' }}
				>
			        年级
			      </TableHeaderColumn>
			      <TableHeaderColumn 
			        dataField='unit'
				filterFormatted
				dataFormat={ this.enumUnitFormatter }
				formatExtraData={ this.state.unitType }
				filter = {{ type: 'SelectFilter',
					options: this.state.unitType,
					selectText: '选择' }}
				>
			        单元
			      </TableHeaderColumn>
			      <TableHeaderColumn dataField='chinese'>
			        中文
			      </TableHeaderColumn>
			      <TableHeaderColumn dataField='english' width={"100"} >
			        单词
			      </TableHeaderColumn>
			      <TableHeaderColumn dataField='past_tense'>
			        过去式 
			      </TableHeaderColumn>
			      <TableHeaderColumn dataField='past_participle'>
			        过去分词
			      </TableHeaderColumn>
			    </BootstrapTable> 
			   </Panel.Body>
			  </Panel>
			  )
	}

}

export default withRouter(Irregular);



// WEBPACK FOOTER //
// ./src/Irregular.js